import { Entitlement, UserEntitlements } from '@ddv/entitlements';

import { Sharing } from '../models/sharing';

// this belongs up further, but until i make more changes to DashboardHeaderName it will stay here
export function canEnterEditMode(
    createdBy: string | undefined,
    isGlobal: boolean | undefined,
    sharing: Sharing | undefined,
    userEntitlements: UserEntitlements,
): boolean {
    if (!sharing || !createdBy) {
        return false;
    }

    if (userEntitlements.hasPermission(Entitlement.DASHBOARD_EDIT)) {
        if (userEntitlements.hasPermission(Entitlement.VIEW_AND_EDIT_ALL)) {
            return true;
        }

        const { username } = userEntitlements.user;

        if (createdBy.toLocaleLowerCase() === username.toLocaleLowerCase()) {
            return true;
        }

        const permission = sharing.toUsers.find((p) => {
            return p.name.toLocaleLowerCase() === username.toLocaleLowerCase() && p.permission === 'write';
        });

        if (permission && isGlobal && userEntitlements.hasGlobalEditPartial()) {
            return true;
        }

        if (permission && !isGlobal) {
            return true;
        }
    }

    return false;
}
